import React from "react";
import clsx from "clsx";
import { Avatar, Tooltip, makeStyles } from "@material-ui/core";
import SupervisedUserCircle from "@material-ui/icons/SupervisedUserCircle";
import UserAvatar from "../UserAvatar";

const useStyles = makeStyles(theme => ({
    badge: {
        position: "absolute", bottom: -4, right: -4, width: 24, height: 24,
        fontSize: "0.70rem", border: theme.palette.type === "dark" ? "2px solid #1c1c1c" : "2px solid #fff",
        borderRadius: "50%", boxShadow: theme.palette.type === "dark" ? "0 2px 6px rgba(0,0,0,0.6)" : "0 2px 6px rgba(0,0,0,0.2)",
        boxSizing: "content-box", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2
    },
    header: { bottom: -8, right: -8 }
}));

export default function TicketAssigneeBadge({ ticket, placement }) {
    const classes = useStyles();
    if (!ticket?.isShared && !ticket?.user) return null;
    const label = ticket.isShared ? "Atendimento compartilhado" : `Atribuído a: ${ticket.user.name}`;
    const badgeClassName = clsx(classes.badge, { [classes.header]: placement === "header" });
    return <Tooltip title={label} enterTouchDelay={0}>
        {ticket.isShared ? <Avatar className={badgeClassName} style={{ backgroundColor: "#e8f5ee" }} tabIndex={0} aria-label={label}>
            <SupervisedUserCircle style={{ color: "#14A45C", width: "125%", height: "125%" }} />
        </Avatar> : <UserAvatar user={ticket.user} className={badgeClassName} showInitials tabIndex={0} aria-label={label} />}
    </Tooltip>;
}
